export function drawSvg(data) {
  // SVG dimensions
  const svgWidth = 160;
  const svgHeight = 160;

  const offset = 2;
  const yOffset = 2;
  const RADIUS = svgHeight / 2 - offset;

  // Create an SVG element
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', svgWidth);
  svg.setAttribute('height', svgHeight);
  svg.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`);

  function getCoordinates(index, value) {
    const r = (value * RADIUS) / 100;
    if (index === 0) {
      return `${RADIUS + offset / 2}, ${RADIUS - (value / 100) * RADIUS + yOffset}`;
    } else if (index === 1) {
      return calculatePointACoordinates(RADIUS, RADIUS, r, 20);
    } else if (index === 2) {
      return calculatePointACoordinates(RADIUS, RADIUS, r, 20 + 140);
    }
  }
  function calculatePointACoordinates(xc, yc, r, angleDegrees) {
    // 将角度转换为弧度
    const angleRadians = angleDegrees * (Math.PI / 180);

    // 计算点A与圆心的连线在水平方向上的投影长度
    const deltaX = r * Math.cos(angleRadians);

    // 计算点A与圆心的连线在垂直方向上的投影长度
    const deltaY = r * Math.sin(angleRadians);

    // 计算点A的坐标
    const xA = xc + deltaX + yOffset;
    const yA = yc + deltaY + yOffset;

    // 返回点A的坐标
    return `${xA},${yA}`;
  }

  // Create the radar chart path
  const pathData = 'M' + data.map((value, index) => getCoordinates(index, value)).join('L') + 'Z';

  const radarChartPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  radarChartPath.setAttribute('d', pathData);
  radarChartPath.setAttribute('stroke', '#30C9CA');
  radarChartPath.setAttribute('stroke-width', '2');
  radarChartPath.setAttribute('fill', 'rgba(48,201,202,0.2)');

  svg.appendChild(radarChartPath);

  return svg;
}
